var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgAx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-ax",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ax-a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M106.3 0h1133.3v850H106.3z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ax-a)",
    transform: "matrix(.56472 0 0 .56482 -60 -.1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0053a5",
    d: "M0 0h1300v850H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffce00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400 0h250v850H400z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 300h1300v250H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#d21034"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475 0h100v850H475z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 375h1300v100H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAx);
export default __webpack_public_path__ + "static/media/ax.dd048088f167a2fc17f43ceae4e6d25f.svg";
export { ForwardRef as ReactComponent };